export default function createStringStore() {
  const stringIds = { "": 0 };
  const stringValues = [""];
  return {
    id: function(str) {
      let result = stringIds[str];
      if (result) {
        return result;
      }
      result = stringIds[str] = stringValues.length;
      stringValues.push(str);
      return result;
    },

    str: function(id) {
      return stringValues[id];
    },
  };
}
